/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Billing_Board_Sort_Name_AscInputs */



/**
* | output |
* | --- |
* | "partner name, A–Z" |
*
* @param {Partner_Billing_Board_Sort_Name_AscInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_billing_board_sort_name_asc = /** @type {((inputs?: Partner_Billing_Board_Sort_Name_AscInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Billing_Board_Sort_Name_AscInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Partnername, A–Z")
	return /** @type {LocalizedString} */ ("partner name, A–Z")
});